export const CUISINE = 'cuisine';
export const LIST_ID = 'list_id';
export const RESY_CREDIT_ELIGIBLE_ONLY = 'resy_credit_eligible_only';
export const TABLE_AREA = 'table_area';
export const VENUE_TYPE = 'venue_type';
